import React from 'react';
import styled, { css } from 'styled-components';
import { BaseBox, FlexBox } from '@docon/docon-ui-library';
import BottomNavBar from './BottomNavBar';
import Header from './Header';
import { bgColor } from 'utilities/colorConfig';
import { isMobileOnly } from 'react-device-detect';

const MainBody = styled(BaseBox)`
  flex: 1;
  overflow: auto;
`;

const Main = styled(FlexBox)`
  flex: 1;
  gap: 20px;
  overflow: auto;

  ${MainBody} {
    max-width: 700px;
    height: 100%;
    padding: 10px;
    /* -webkit-overflow-scrolling: touch; */
  }
`;

const Root = styled(FlexBox)`
  height: var(--app-height, 100vh);
  max-height: -webkit-fill-available;
  flex-direction: column;
  flex-wrap: nowrap;
  background-color: ${bgColor.base};

  ${() => isMobileOnly && css`
    ${Main} {
      gap: 10px;
      margin: 0;
      flex-direction: column;
      flex-wrap: nowrap;
    }

    ${MainBody} {
      padding-left: 16px;
      padding-right: 16px;
      width: 100%;
      max-width: 100vw !important;
    }
  `}
`;

export interface IProps {
  hideHeader?: boolean;
  hideFooter?: boolean;
  className?: string;
  children: any;
  header?: any;
}

function Layout({
  hideHeader,
  hideFooter,
  className,
  children,
  header,
}: IProps) {

  return (
    <Root className={className}>
      {
        hideHeader ? null : header || <Header />
      }

      <Main>
        {
          hideFooter ? null : <BottomNavBar />
        }

        <MainBody id='mainBody'>{children}</MainBody>
      </Main>

    </Root>
  );
}

export {
  MainBody,
};

export default Layout;